import { render } from "./HostAcknowledge.vue?vue&type=template&id=8d9c423c"
import script from "./HostAcknowledge.vue?vue&type=script&lang=js"
export * from "./HostAcknowledge.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__